import React from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form, Input, Button, message, Checkbox, Tooltip } from 'antd';
import queryString from 'query-string';

import CloudFlyerAPI  from '../../../api/CloudFlyerAPI';
import EnvelopeImg from '../../../assets/img/envelope.png';
import wasabiDarkLogo from '../../../assets/logo/wasabi_header_logo_dark.png';
import './resetPassword.scss';

class ResetPasswords extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
          loading      : false,
          request_sent : false,
          token        : null,
          email        : null,
          valid        : false,
          isSamePass   : false,
          password     : "",
          passwordVisited: false,
          repasswordVisited: false
        }
      }
    
    componentDidMount(){
        let token = this.props.location.search.replace('?token=', '')
        console.log(token)
        this.setState({token:token, request_sent:!!token})
        
    }

    onFocus(which) {
        if (which === 'password') {
            this.setState({passwordVisited: true})
        }else {
            this.setState({repasswordVisited: true})
        }
    }

    onPassChange = (e) => {
        const passValue = e.target.value
        const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d@$!%*#?&.]{8,}$/g
        this.setState({valid: regex.test(passValue), password: passValue})
    }

    onRePassChange = (e) => {
        const { password } = this.state
        const repassValue = e.target.value
        this.setState({isSamePass: password === repassValue})
    }

    on_request = email =>{
        let $this = this
        email = email ? email : this.props.form.getFieldsValue().email
        $this.setState({loading:true})

        CloudFlyerAPI
            .user_account
            .request_reset_password(email)
            .then(()=>{
            message.success('Email sent successfully, please check your email.')
            $this.setState({request_sent:true, loading:false, email})
            })
            .catch(err=>{
            message.error(err.message)
            $this.setState({request_sent:false, loading:false})
            })
    }
    
    on_reset = async () => {
        // let $this = this

        let {pass, pass_conf} = this.props.form.getFieldsValue()
        if(pass !== pass_conf){
            return message.error('Passwords do not match. Please make sure they are correct.')
        }
        
        try{
            this.setState({loading:true})

            const {data} = await CloudFlyerAPI.new_user_account.request_temp_token();

            await CloudFlyerAPI.new_user_account.resetPassword(pass, this.state.token, data);
            message.success('Password has been reset.')
            this.setState({loading:false}, this.on_login)
        }
        catch(err){
            this.setState({loading:false})
            message.error(((err.response||{}).data||{}).message)
        }

        // $this.setState({loading:true})
        // CloudFlyerAPI
        //     // .user_account
        //     .new_user_account.resetPassword({password:pass, reset_password_token:this.state.token})
        //     .then(()=>{
        //     message.success('Password has been reset.')
        //     $this.setState({loading:false}, this.on_login)
        //     })
        //     .catch(err=>{
        //     $this.setState({loading:false})
        //     message.error(((err.response||{}).data||{}).message)
        //     })
    }

    on_login = ()=> {
    const { history } = this.props
    history.push('/login')
    }

    render(){
        console.log("request_sent", request_sent);

        const { getFieldDecorator } = this.props.form
        const {
            request_sent,
            email,
            token,
            valid,
            isSamePass,
            passwordVisited,
            repasswordVisited
            } = this.state
            
            console.log(!token)
        if (!token){
            console.log(!token)
            //return <Redirect to={{ pathname: '/login' }}/>
        }            
        const tooltipTxt = 'Password requirements were not met. Password requirements: at least 8 characters, a lowercase letter, an uppercase letter, a number.'
        // let formHeader = token ? formHeader = 'Create your new password.' : (request_sent ? formHeader = '' : 'Enter your email address to reset your password.');

        return(
            <div className="resetPass-wrapper">

                <div className="resetPass-form-box">

                    <div className="wasabiLogo">
                        <img alt="wasabi Logo" src={wasabiDarkLogo} />
                    </div>

                    <div className="resetPass-form-input">
                        <h4 className="resetPass-title">
                            <h3>{token ? 'Create your new password.' : (request_sent ? '' : 'Enter your email address to reset your password.')}</h3>

                            {/* {formHeader} */}
                        </h4>
                        <div>
                            {
                                !token && request_sent ? <img src={EnvelopeImg} alt="" /> :
                                <Form
                                layout="horizontal"
                                className="resetPass-form"
                                onSubmit = {e => {e.preventDefault() 
                                token ? this.on_reset() : this.on_request()}}>
                                    {
                                        token ?
                                            [
                                                <Form.Item key='pass'>
                                                    <Tooltip visible={passwordVisited && !valid} title={tooltipTxt} placement="topRight">
                                                    {getFieldDecorator('pass')(
                                                        <Input className="input" type='password' placeholder='New Password' onChange={this.onPassChange}  onFocus={() => this.onFocus('password')} />
                                                    )}
                                                    </Tooltip>
                                                </Form.Item>,
                                                <Form.Item key='pass_conf'>
                                                    <Tooltip placement="topRight" visible={repasswordVisited && !isSamePass}  title="Passwords do not match. Please make sure they are correct." >
                                                        {getFieldDecorator('pass_conf')(
                                                            <Input className="input" type='password' placeholder='Confirm Password' onChange={this.onRePassChange} onFocus={() => this.onFocus('repassword')} />
                                                        )}
                                                    </Tooltip>
                                                </Form.Item>,
                                                <div className="terms">
                                                    {/* <Form.Item  name="policy" valuePropName="checked">
                                                        <Checkbox></Checkbox>
                                                    </Form.Item>
                                                    <Form.Item>
                                                        <p>I accept the Wasabi Bucket Replication Manager 
                                                            <a
                                                            target="_blank"
                                                            href="/">
                                                            Terms and Conditions
                                                            </a>
                                                        </p>
                                                    </Form.Item> */}
                                                </div>
                                            ]
                                            :
                                            <Form.Item>
                                                {getFieldDecorator('email')(
                                                    <Input className="input" placeholder='Email' />
                                                )}
                                            </Form.Item>
                                    }
                                    
                                    <Form.Item>
                                        <Button
                                            className="btn-login"
                                            type="primary"
                                            size="large"
                                            loading={this.state.loading}
                                            htmlType="submit"
                                            block
                                            disabled={!passwordVisited || !repasswordVisited || !valid || !isSamePass}>
                                            Reset
                                        </Button>
                                    </Form.Item>
                                </Form>
                            }
                        </div>
                    </div>
                    <div className="cs-text">
                        {
                            !token && request_sent ? [
                            <p key='1'>We sent you a reset email to:</p>,
                            <p key='2' className="email">{email}</p>,
                            <p key='3'>Please check your email and use the reset link to reset your password.</p>,
                            <p key='4' className="small">Didn’t get the reset email? <a href="#" onClick={()=> this.on_request(email)}>resend email</a> or <a href="#" onClick={this.on_login}>Login</a></p>
                            ] : <p key='4' className="small remember-pass">Remember your password? go to <a href="#" onClick={this.on_login}>login</a> page</p>
                        }
                    </div>
                </div>
            </div>
        )
    }

}
export default withRouter(Form.create()(ResetPasswords))
